"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _collapse_props = require("./collapse_props");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Collapse =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Collapse, _PureComponent);

  function Collapse(props) {
    var _this;

    _classCallCheck(this, Collapse);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Collapse).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "updateView", function () {
      _this.forceUpdate();
    });

    _this.nullList();

    _this.handleTransitionEnd = _this.handleTransitionEnd.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Collapse, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init();

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setOpen();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.nullList();
    }
  }, {
    key: "nullList",
    value: function nullList() {
      this.childrenRef = null;
      this.timeout = null;
    } // 展开中的className

  }, {
    key: "openingClassName",
    value: function openingClassName() {
      var transitionAppear = this.props.transitionAppear;
      (0, _spauiUtils.removeClassName)(this.childrenRef, 'collapse');
      (0, _spauiUtils.removeClassName)(this.childrenRef, 'in');

      if (transitionAppear) {
        (0, _spauiUtils.addClassName)(this.childrenRef, 'collapsing');
      }
    } // 展开的className

  }, {
    key: "openClassName",
    value: function openClassName() {
      (0, _spauiUtils.removeClassName)(this.childrenRef, 'collapsing');
      (0, _spauiUtils.removeClassName)(this.childrenRef, 'collapse');
      (0, _spauiUtils.removeClassName)(this.childrenRef, 'in');
      (0, _spauiUtils.addClassName)(this.childrenRef, 'collapse');
      (0, _spauiUtils.addClassName)(this.childrenRef, 'in');
    } // 不展开的className

  }, {
    key: "unOpenClassName",
    value: function unOpenClassName() {
      (0, _spauiUtils.removeClassName)(this.childrenRef, 'collapsing');
      (0, _spauiUtils.removeClassName)(this.childrenRef, 'collapse');
      (0, _spauiUtils.removeClassName)(this.childrenRef, 'in');
      (0, _spauiUtils.addClassName)(this.childrenRef, 'collapse');
    } // 获取内容结构的react信息

  }, {
    key: "getRect",
    value: function getRect() {
      var result = {
        height: 0
      };

      if (this.childrenRef) {
        if (this.childrenRef.style) {
          this.childrenRef.style.height = 'auto';
        }

        result = this.childrenRef.getBoundingClientRect();
      }

      return result;
    } // 初始化展开状态

  }, {
    key: "init",
    value: function init() {
      var open = this.props.open;

      if (this.childrenRef) {
        if (open) {
          this.openClassName();

          if (this.childrenRef.style) {
            this.childrenRef.style.height = 'auto';
            this.childrenRef.setAttribute('data-open', 1);
          }

          this.childrenRef.style.overflow = '';
        } else {
          this.childrenRef.setAttribute('data-open', -1);
        }
      }
    } // 根据状态来设置是否展开

  }, {
    key: "setOpen",
    value: function setOpen() {
      var _this2 = this;

      var _this$props = this.props,
          open = _this$props.open,
          updateTimeout = _this$props.updateTimeout;
      var rect = null;
      var dataOpen = '';

      if (this.childrenRef) {
        dataOpen = this.childrenRef.getAttribute('data-open');

        if (!dataOpen || open && dataOpen < 0 || !open && dataOpen > 0) {
          this.openingClassName();
          clearTimeout(this.timeout);

          if (open) {
            rect = this.getRect();

            if (this.childrenRef && this.childrenRef.style) {
              this.childrenRef.style.height = '0px';
            }

            this.timeout = setTimeout(function () {
              if (_this2.childrenRef) {
                if (_this2.childrenRef.style) {
                  _this2.childrenRef.style.height = "".concat(rect.height, "px");
                }

                _this2.childrenRef.setAttribute('data-open', 1);
              }
            }, updateTimeout);
          } else {
            // 收起时，由于需要有动画，先将 auto 高度转换为实际的高度
            if (this.childrenRef && this.childrenRef.style) {
              rect = this.getRect();
              this.childrenRef.style.height = "".concat(rect.height, "px");
            }

            this.timeout = setTimeout(function () {
              if (_this2.childrenRef) {
                if (_this2.childrenRef.style) {
                  _this2.childrenRef.style.height = '0px';
                } // 不需要展示动画，元素要在这里直接隐藏


                if (!_this2.transitionAppear && _this2.childrenRef.style) {
                  _this2.childrenRef.style.overflow = 'hidden';
                }

                _this2.childrenRef.setAttribute('data-open', -1);
              }
            }, updateTimeout);
          }
        }
      }
    }
  }, {
    key: "handleTransitionEnd",
    value: function handleTransitionEnd() {
      var _this$props2 = this.props,
          open = _this$props2.open,
          onTransitionEnd = _this$props2.onTransitionEnd;

      if (this.childrenRef) {
        if (open) {
          this.openClassName();
          this.childrenRef.style.height = 'auto';
          this.childrenRef.style.overflow = '';
        } else {
          this.childrenRef.style.overflow = 'hidden';
          this.unOpenClassName();
        }

        if ((0, _spauiUtils.isFunction)(onTransitionEnd)) {
          onTransitionEnd(this.childrenRef);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var children = this.props.children;
      var _children$props = children.props,
          props = _children$props === void 0 ? {} : _children$props;
      var style = (0, _spauiUtils.objectAssign)(props.style || {}, {
        height: '0px',
        overflow: 'hidden'
      });
      return (0, _react.cloneElement)(children, _objectSpread({}, (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])('spaui-collapse', 'collapse')
      }, Collapse, this.props), {
        style: style,
        ref: function ref(el) {
          _this3.childrenRef = el;
        },
        onTransitionEnd: this.handleTransitionEnd
      }));
    }
  }]);

  return Collapse;
}(_react.PureComponent); // 组件标记


_defineProperty(Collapse, "propTypes", _collapse_props.propTypes);

_defineProperty(Collapse, "defaultProps", _collapse_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Collapse, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Collapse;
exports["default"] = _default;